import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "@emotion/react";
import Theme from "./Themes/Theme";
import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import ContentLayout from "./layouts/Form/ContentLayout";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./layouts/Navbar/Navbar";
import Footer from "./layouts/Footer/Footer";
import Loading from "./components/Loading";
import Notification from "./components/Notification";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter forceRefresh={true}>
      <ThemeProvider theme={Theme}>
        <SnackbarProvider maxSnack={3}>
          <AuthProvider>
            <ContentLayout>
              <Navbar />
              <App />
              <Loading />
              <Notification />
              <Footer />
            </ContentLayout>
          </AuthProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
